import { Query } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import fetchExternalAccountsForTransferSource from 'services/graphql/queries/FetchExternalAccountsForTransferSource';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

interface useExternalAccountsForTransferSourceProps {
  shouldPause?: boolean;
}

const useExternalAccountsForTransferSource = ({
  shouldPause = false,
}: useExternalAccountsForTransferSourceProps = {}) => {
  const router = useRouter();
  const [{ data, fetching: loading, error }, refetchExternalAccounts] =
    useQuery<Query>({
      query: fetchExternalAccountsForTransferSource,
      requestPolicy: 'cache-and-network',
      pause: shouldPause,
    });

  const externalAccounts = data?.myAccounts?.forTransferSource?.external ?? [];

  const refresh = () => {
    refetchExternalAccounts({ requestPolicy: 'network-only' });
  };

  const { defaultTitle, defaultMessage, retryButtonTitle, cancelButtonTitle } =
    useDefaultErrorStrings();

  const responseError = useFormattedCombinedError(error);

  const buttons = {
    primaryButton: {
      title: retryButtonTitle,
      onPress: refresh,
    },
    secondaryButton: {
      title: cancelButtonTitle,
      onPress: () => {
        router.back();
      },
    },
  };

  const errorModel = error
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: responseError?.title ?? defaultTitle,
        messageBody: responseError?.message ?? defaultMessage,
        ...buttons,
      }
    : null;

  return {
    errorModel,
    loading,
    response: externalAccounts,
    refresh,
  };
};

export default useExternalAccountsForTransferSource;
